module.exports = __webpack_public_path__ + "static/media/users.4a26ca28.svg";